// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prices_pricesPage__P7WMk {
  background: #f5f7fb;
}

.prices_container__5CySp {
  width: min(1160px, 100%);
  margin: 0 auto;
  padding: 0 16px;
}

.prices_pageTitle__Z1x-g {
  font-size: 32px;
  font-weight: 700;
  color: #24346d;
  margin-bottom: 32px;
}

/* SEARCH BOX */
.prices_searchBox__ERFBS {
  margin-bottom: 32px;
}

.prices_searchInput__IDwUC {
  width: 100%;
  padding: 14px 20px;
  border-radius: 50px;
  border: 1px solid #d0d4e4;
  font-size: 16px;
  outline: none;
  transition: 0.2s ease;
}
.prices_searchInput__IDwUC:focus {
  border-color: #24346d;
  box-shadow: 0 0 0 3px rgba(36, 52, 109, 0.15);
}

/* TABS */
.prices_tabs__8zmKn {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 32px;
}

.prices_tabButton__kIAdT {
  padding: 10px 20px;
  border-radius: 30px;
  border: 1px solid #d0d4e4;
  background: white;
  font-size: 15px;
  color: #24346d;
  cursor: pointer;
  transition: all 0.25s ease;
}
.prices_tabButton__kIAdT:hover {
  border-color: #24346d;
}

.prices_tabButtonActive__pmO27 {
  background: #24346d;
  color: #fff;
  border-color: #24346d;
}

/* CATEGORY TITLES */
.prices_categoryWrapper__swB\\+F {
  margin-bottom: 40px;
}

.prices_categoryTitle__2oHSz {
  font-size: 22px;
  font-weight: 600;
  color: #24346d;
  margin-bottom: 16px;
}

/* ACCORDION */
.prices_accordionGroup__tn68N {
  border-radius: 18px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);
}

.prices_accordionItem__45qmP + .prices_accordionItem__45qmP {
  border-top: 1px solid #e5e7ef;
}

.prices_accordionHeader__sk7YP {
  padding: 18px 20px;
  width: 100%;
  background: transparent;
  border: none;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.prices_accordionTitle__4SfqY {
  color: #24346d;
  font-size: 17px;
  font-weight: 600;
}

.prices_accordionIcon__fQSI5 {
  font-size: 18px;
  color: #24346d;
  transition: transform 0.25s ease;
}

.prices_accordionIconOpen__pYyAn {
  transform: rotate(180deg);
}

.prices_accordionBody__-Nnzw {
  padding: 12px 20px 20px;
  border-top: 1px solid #eef0f6;
}

/* SERVICE ROW */
.prices_serviceRow__lcZW1 {
  display: flex;
  justify-content: space-between;
  padding: 14px 0;
  gap: 16px;
  border-bottom: 1px dashed #e5e7ef;
}
.prices_serviceRow__lcZW1:last-child {
  border-bottom: none;
}

.prices_serviceText__DYj4U {
  flex: 1 1;
}

.prices_serviceName__UGSMa {
  font-size: 16px;
  font-weight: 500;
  color: #1f244b;
  margin-bottom: 6px;
}

.prices_serviceDescription__IJqeQ {
  margin: 0 0 6px 18px;
  padding: 0;
  list-style: disc;
  font-size: 14px;
  color: #4a4f6b;
}
.prices_serviceDescription__IJqeQ li + li {
  margin-top: 3px;
}

.prices_serviceNote__7LxIO {
  font-size: 13px;
  color: #8b90a9;
  font-style: italic;
}

.prices_servicePrice__qq6qU {
  font-size: 16px;
  font-weight: 700;
  color: #24346d;
  white-space: nowrap;
}

/* ----------- RESPONSIVE IMPROVED ----------- */
@media (max-width: 992px) {
  .prices_pageTitle__Z1x-g {
    font-size: 28px;
  }
  .prices_serviceRow__lcZW1 {
    flex-direction: column;
    align-items: flex-start;
  }
  .prices_servicePrice__qq6qU {
    margin-top: 4px;
    font-size: 15px;
  }
}
@media (max-width: 768px) {
  .prices_accordionHeader__sk7YP {
    padding: 16px;
  }
  .prices_accordionTitle__4SfqY {
    font-size: 15px;
  }
  .prices_serviceName__UGSMa {
    font-size: 15px;
  }
  .prices_serviceDescription__IJqeQ {
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .prices_pageTitle__Z1x-g {
    font-size: 24px;
  }
  .prices_tabButton__kIAdT {
    width: 100%;
    text-align: center;
  }
  .prices_serviceRow__lcZW1 {
    padding: 12px 0;
  }
  .prices_accordionGroup__tn68N {
    border-radius: 14px;
  }
  .prices_accordionHeader__sk7YP {
    padding: 14px;
  }
  .prices_accordionBody__-Nnzw {
    padding: 12px 14px 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/stylePricePage/prices.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA,eAAA;AACA;EACE,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;AACF;AACE;EACE,qBAAA;EACA,6CAAA;AACJ;;AAGA,SAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AAAF;AAEE;EACE,qBAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AADF;;AAIA,oBAAA;AACA;EACE,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AADF;;AAIA,cAAA;AACA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,gCAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,uBAAA;EACA,6BAAA;AADF;;AAIA,gBAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,iCAAA;AADF;AAGE;EACE,mBAAA;AADJ;;AAKA;EACE,SAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAFF;AAIE;EACE,eAAA;AAFJ;;AAMA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAHF;;AAMA,gDAAA;AAEA;EACE;IACE,eAAA;EAJF;EAOA;IACE,sBAAA;IACA,uBAAA;EALF;EAQA;IACE,eAAA;IACA,eAAA;EANF;AACF;AASA;EACE;IACE,aAAA;EAPF;EAUA;IACE,eAAA;EARF;EAWA;IACE,eAAA;EATF;EAYA;IACE,eAAA;EAVF;AACF;AAaA;EACE;IACE,eAAA;EAXF;EAcA;IACE,WAAA;IACA,kBAAA;EAZF;EAeA;IACE,eAAA;EAbF;EAgBA;IACE,mBAAA;EAdF;EAiBA;IACE,aAAA;EAfF;EAkBA;IACE,uBAAA;EAhBF;AACF","sourcesContent":[".pricesPage {\r\n  background: #f5f7fb;\r\n}\r\n\r\n.container {\r\n  width: min(1160px, 100%);\r\n  margin: 0 auto;\r\n  padding: 0 16px;\r\n}\r\n\r\n.pageTitle {\r\n  font-size: 32px;\r\n  font-weight: 700;\r\n  color: #24346d;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n/* SEARCH BOX */\r\n.searchBox {\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.searchInput {\r\n  width: 100%;\r\n  padding: 14px 20px;\r\n  border-radius: 50px;\r\n  border: 1px solid #d0d4e4;\r\n  font-size: 16px;\r\n  outline: none;\r\n  transition: 0.2s ease;\r\n\r\n  &:focus {\r\n    border-color: #24346d;\r\n    box-shadow: 0 0 0 3px rgba(36, 52, 109, 0.15);\r\n  }\r\n}\r\n\r\n/* TABS */\r\n.tabs {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.tabButton {\r\n  padding: 10px 20px;\r\n  border-radius: 30px;\r\n  border: 1px solid #d0d4e4;\r\n  background: white;\r\n  font-size: 15px;\r\n  color: #24346d;\r\n  cursor: pointer;\r\n  transition: all 0.25s ease;\r\n\r\n  &:hover {\r\n    border-color: #24346d;\r\n  }\r\n}\r\n\r\n.tabButtonActive {\r\n  background: #24346d;\r\n  color: #fff;\r\n  border-color: #24346d;\r\n}\r\n\r\n/* CATEGORY TITLES */\r\n.categoryWrapper {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.categoryTitle {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  color: #24346d;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n/* ACCORDION */\r\n.accordionGroup {\r\n  border-radius: 18px;\r\n  background: #fff;\r\n  overflow: hidden;\r\n  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.accordionItem + .accordionItem {\r\n  border-top: 1px solid #e5e7ef;\r\n}\r\n\r\n.accordionHeader {\r\n  padding: 18px 20px;\r\n  width: 100%;\r\n  background: transparent;\r\n  border: none;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  cursor: pointer;\r\n}\r\n\r\n.accordionTitle {\r\n  color: #24346d;\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n}\r\n\r\n.accordionIcon {\r\n  font-size: 18px;\r\n  color: #24346d;\r\n  transition: transform 0.25s ease;\r\n}\r\n\r\n.accordionIconOpen {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.accordionBody {\r\n  padding: 12px 20px 20px;\r\n  border-top: 1px solid #eef0f6;\r\n}\r\n\r\n/* SERVICE ROW */\r\n.serviceRow {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 14px 0;\r\n  gap: 16px;\r\n  border-bottom: 1px dashed #e5e7ef;\r\n\r\n  &:last-child {\r\n    border-bottom: none;\r\n  }\r\n}\r\n\r\n.serviceText {\r\n  flex: 1;\r\n}\r\n\r\n.serviceName {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #1f244b;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.serviceDescription {\r\n  margin: 0 0 6px 18px;\r\n  padding: 0;\r\n  list-style: disc;\r\n  font-size: 14px;\r\n  color: #4a4f6b;\r\n\r\n  li + li {\r\n    margin-top: 3px;\r\n  }\r\n}\r\n\r\n.serviceNote {\r\n  font-size: 13px;\r\n  color: #8b90a9;\r\n  font-style: italic;\r\n}\r\n\r\n.servicePrice {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #24346d;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ----------- RESPONSIVE IMPROVED ----------- */\r\n\r\n@media (max-width: 992px) {\r\n  .pageTitle {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .serviceRow {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .servicePrice {\r\n    margin-top: 4px;\r\n    font-size: 15px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .accordionHeader {\r\n    padding: 16px;\r\n  }\r\n\r\n  .accordionTitle {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .serviceName {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .serviceDescription {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .pageTitle {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .tabButton {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  .serviceRow {\r\n    padding: 12px 0;\r\n  }\r\n\r\n  .accordionGroup {\r\n    border-radius: 14px;\r\n  }\r\n\r\n  .accordionHeader {\r\n    padding: 14px;\r\n  }\r\n\r\n  .accordionBody {\r\n    padding: 12px 14px 14px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pricesPage": `prices_pricesPage__P7WMk`,
	"container": `prices_container__5CySp`,
	"pageTitle": `prices_pageTitle__Z1x-g`,
	"searchBox": `prices_searchBox__ERFBS`,
	"searchInput": `prices_searchInput__IDwUC`,
	"tabs": `prices_tabs__8zmKn`,
	"tabButton": `prices_tabButton__kIAdT`,
	"tabButtonActive": `prices_tabButtonActive__pmO27`,
	"categoryWrapper": `prices_categoryWrapper__swB+F`,
	"categoryTitle": `prices_categoryTitle__2oHSz`,
	"accordionGroup": `prices_accordionGroup__tn68N`,
	"accordionItem": `prices_accordionItem__45qmP`,
	"accordionHeader": `prices_accordionHeader__sk7YP`,
	"accordionTitle": `prices_accordionTitle__4SfqY`,
	"accordionIcon": `prices_accordionIcon__fQSI5`,
	"accordionIconOpen": `prices_accordionIconOpen__pYyAn`,
	"accordionBody": `prices_accordionBody__-Nnzw`,
	"serviceRow": `prices_serviceRow__lcZW1`,
	"serviceText": `prices_serviceText__DYj4U`,
	"serviceName": `prices_serviceName__UGSMa`,
	"serviceDescription": `prices_serviceDescription__IJqeQ`,
	"serviceNote": `prices_serviceNote__7LxIO`,
	"servicePrice": `prices_servicePrice__qq6qU`
};
export default ___CSS_LOADER_EXPORT___;
